<template>
  <div class="avatar notranslate" :style="avatarSizeStyle">
    <div v-if="!avatarPhotoUrl" class="no-photo">
      {{ noAvatarPhotoUrl }}
    </div>
    <div v-else class="avatar-url" :style="avatarBgStyle"></div>
  </div>
</template>

<script>
export default {
  name: 'Avatar',
  data() {
    return {
    };
  },
  computed: {
    avatarPhotoUrl() {
      if (!this.photoUrl) {
        return '';
      } else {
        return this.photoUrl;
      }
    },
    avatarBgStyle() {
      return `background-image: url(${this.avatarPhotoUrl})`;
    },
    noAvatarPhotoUrl() {
      const nameArray = this.avatarName ? this.avatarName.split(' ') : ['X', 'X'];

      if (nameArray.length === 1) {
        return `${nameArray[0].toUpperCase().substr(0, 1)}`;
      }
      if (nameArray.length > 1) {
        return `${nameArray[0].toUpperCase().substr(0, 1)}${nameArray[1].toUpperCase().substr(0, 1)}`;
      }

      return 'XX';
    },
    avatarSizeStyle() {
      return `
        width: ${this.width}px;
        height: ${this.height}px;
        font-size: ${this.fontSize}px;
      `;
    },
  },
  props: {
    photoUrl: {
      type: String,
      default() {
        return '';
      },
    },
    avatarName: {
      type: String,
      default() {
        return '';
      },
    },
    width: {
      type: Number,
      default() {
        return 45;
      },
    },
    height: {
      type: Number,
      default() {
        return 45;
      },
    },
    fontSize: {
      type: Number,
      default() {
        return 16;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import './../../sass/main.scss';

.avatar {
  position: relative;
  border-radius: 50%;
  border: 1px solid $border-color-light;
  background-color: $tab-active;
  @include center-style;

  .avatar-url {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center center;
  }

  .no-photo {
    position: absolute;
    width: 100%;
    height: 100%;
    letter-spacing: 1px;
    border-radius: 50%;
    color: $font-color-white;
    @include center-style;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Avatar.vue